var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaverseStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0112 2L20.8225 7.08735V15.9563C20.8225 16.3532 20.718 16.7431 20.5196 17.0868C20.3211 17.4305 20.0357 17.7159 19.692 17.9144L13.1418 21.6971C12.798 21.8955 12.4081 22 12.0112 22C11.6143 22 11.2244 21.8955 10.8807 21.6971L4.33047 17.9144C3.98676 17.7159 3.70134 17.4305 3.50289 17.0868C3.30444 16.7431 3.19996 16.3532 3.19995 15.9563V7.08735L12.0112 2Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0114 6.52197V12.1746M12.0114 12.1746L7.11621 15.0009M12.0114 12.1746L16.9065 15.0009",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverseStore);
export default __webpack_public_path__ + "static/media/metaverse-store.c8706ce723a9f4ff508df24cf5455c7b.svg";
export { ForwardRef as ReactComponent };